import { Fragment, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Map from "~/components/Map";

import AuthService from "services/http/AuthService";
const auth = new AuthService();

const MapView = ({ myUser, getMyCompany, getUserMe }) => {
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    auth.logout();
    navigate("/login");
  }, [navigate]);

  const hasPermission = useCallback(() => {
    return myUser && (myUser?.is_staff === true || myUser?.status === 100);
  }, [myUser]);

  useEffect(() => {
    getMyCompany().then(
      (response) => {
        getUserMe(response?.id).then(
          () => {},
          (_errors) => {
            handleLogout();
          },
        );
      },
      (_errors) => {
        handleLogout();
      },
    );
  }, [getMyCompany, getUserMe, handleLogout]);

  return (
    <Fragment>
      {/*
        <div style={{zIndex: 1001, padding: '32px', position: 'absolute', left:'0px',top:'0px', }}>
          <img src={OpenTaxiLogo} style={{width: '256px'}} />
        </div>
      */}
      {hasPermission() && <Map />}
    </Fragment>
  );
};

export default MapView;
